var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.1168 2.40527H2.90405V26.6141H38.1168V2.40527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0457 14.7703L38.1177 3.83438V24.9802L27.0457 14.793V14.7703ZM4.85621 2.40499H36.1438L20.5113 17.924L4.8789 2.40499H4.85621ZM4.60664 26.6138L15.656 16.4492L19.4677 20.2156C19.8761 20.6013 20.103 20.7374 20.4887 20.7374C20.8744 20.7374 21.1012 20.5786 21.5096 20.2156L25.3213 16.4492L36.3707 26.6138H4.60664ZM2.90499 24.9347V3.83438L13.9543 14.7476L2.90499 24.9122V24.9347ZM1.83863 29.0188H39.2975C39.9328 29.0188 40.5 28.4742 40.5 27.8162V1.20256C40.5 0.567281 39.9555 0 39.2975 0H1.7025C1.06721 0 0.5 0.544593 0.5 1.20256V27.6574C0.5 28.4515 0.953772 29.0188 1.83863 29.0188Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.67421789423397a40bddfee048230b79.svg";
export { ForwardRef as ReactComponent };